import React, { useRef } from 'react'
import { MapContainer,Marker,Popup,TileLayer } from 'react-leaflet'
import l from 'leaflet'
import 'leaflet/dist/leaflet.css'

const GloryMap = () => {
    const ref=useRef()
    const maker=new l.icon({
        iconUrl:'https://unpkg.com/leaflet@1.6.0/dist/images/marker-icon-2x.png',
        iconSize:[25,35],
        popupAnchor:[65,-65],
       iconAnchor:[-50,70]
    })
  return (
    <div>
         <MapContainer center={[6.6727413,-1.5630001]} zoom={13} ref={ref}>
        <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
        <Marker position={[6.6763964,-1.5560116]} icon={maker}>
            <Popup>
                <h3>Glory Be To God</h3>
            </Popup>
        </Marker>
      </MapContainer>
    </div>
  )
}

export default GloryMap